// extracted by mini-css-extract-plugin
export default {"container":"xq-z","heading":"yq-z","text":"zq-z","info":"Aq-z","link":"Bq-z","fullMaxWidth":"Cq-z"};